import footfallEventTypes from 'js/config/footfallEventTypes';
import config from 'js/config';
import { trackFootfallEvent, trackFootfallEventWithHrefDelay } from './footfall';

const analytics = {

  trackPageView(userType) {
    this.trackFootfallEvent(footfallEventTypes.VIEWED_PAGE);

    // Remove the unread notifications/messages count
    const pageTitle = document.title.split(') ').pop();

    // Configure custom dimensions for GA4 property
    window.gtag('config', config.build.ga4TrackingId, {
      'custom_map': { 'dimension1': 'fe_type', 'dimension2': 'user_type' },
      'send_page_view': false, // disable the default page view event
      'fe_type': 'betelgeuse',
      'user_type': userType,
    });

    // Configure custom dimensions for UA property
    let customDimensions = { 'dimension9': 'fe_type', 'dimension10': 'user_type' };
    if (config.build.gaTrackingId === 'UA-11066411-23') { // Betelgeuse Staging
      customDimensions = { 'dimension4': 'fe_type', 'dimension5': 'user_type' };
    }
    window.gtag('config', config.build.gaTrackingId, {
      'custom_map': customDimensions,
      'send_page_view': false, // disable the default page view event
      'fe_type': 'betelgeuse',
      'user_type': userType,
    });

    // Send manual page view event
    window.gtag('event', 'page_view', {
      'page_location': location.href,
      'page_path': location.pathname + location.search + location.hash,
      'page_title': pageTitle,
      'send_to': [config.build.ga4TrackingId, config.build.gaTrackingId],
    });
  },

  // Track a custom event for UA property
  trackEvent(category, action, label = undefined, value = undefined, isNonInteraction = false) {
    window.gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'value': value,
      'non_interaction': isNonInteraction,
      'send_to': config.build.gaTrackingId, // only send to UA property
    });
  },

  // Track Account created event for GA4 property
  trackAccountCreatedEvent(action) {
    window.gtag('event', 'account_created', {
      'action': action,
      'user_type': 'Member',
      'send_to': config.build.ga4TrackingId, // only send to G4 property
    });
  },

  // Community tracking for admins - page view
  trackPageForPartner() {
    const currentGroup = window.app.context.getGroup();
    if (!currentGroup || !currentGroup.gaTrackingCode) return;

    // Remove the unread notifications/messages count
    const pageTitle = document.title.split(') ').pop();

    // By default the config command sends a pageview
    window.gtag('config', currentGroup.gaTrackingCode, {
      'page_location': location.href,
      'page_path': location.pathname + location.search + location.hash,
      'page_title': pageTitle,
      'send_to': currentGroup.gaTrackingCode, // only send to partner property
    });
  },

  // Community tracking for admins - event
  trackEventForPartner(category, action, label, value) {
    const currentGroup = window.app.context.getGroup();
    if (!currentGroup || !currentGroup.gaTrackingCode) return;

    window.gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'value': value,
      'send_to': currentGroup.gaTrackingCode, // only send to partner property
    });
  },
  trackFootfallEvent: trackFootfallEvent,
  trackFootfallEventWithHrefDelay: trackFootfallEventWithHrefDelay,
};

window.trackFootfallEvent = analytics.trackFootfallEvent;

module.exports = analytics;



// WEBPACK FOOTER //
// ./app/assets/js/analytics.js